import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';

const useAgentFeatureFlag = () => {
  const { ISPM_SERVICES_ENABLED: isIspmEnabled } = useSelector(
    (state) => state.user.domainInfo || {}
  );
  const { OMNIFLOW_ENABLED: isOmniflowEnabled } = useSelector(
    (state) => state.user.agentRequestConfig || { OMNIFLOW_ENABLED: null }
  );
  const { pathname } = useLocation();

  const isOmniflowRoute = Boolean(
    pathname.includes('/agent/request') ||
      pathname.includes('/agent/user') ||
      pathname.includes('/agent/configuration') ||
      pathname.includes('/agent/request/create') ||
      pathname.includes('/agent/manage/request')
  );

  const isMfeEnabled = Boolean(
    (isOmniflowRoute && isOmniflowEnabled) || (!isOmniflowRoute && isIspmEnabled)
  );

  return {
    isMfeEnabled,
    isLoading: isOmniflowRoute && isOmniflowEnabled === null,
    isError: false,
  };
};

export default useAgentFeatureFlag;
